import * as yup from "yup"

export const validationSchema = yup.object().shape({
    account_type_code: yup.string().label("Code").required().min(2).max(3),
    account_type_name: yup.string().label("Name Type").required().max(100, "Must be 100 characters or less"),
    description: yup.string().label("Description")
  })